import { Card, Text, Tooltip } from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';

import type { UsageKpiCardsProps } from './DatasetUsageSection.interface.js';
import { useStyles } from './DatasetUsageSection.style.js';

const TOTAL_ACTIONS_LABEL = 'Total Actions';
const PEAK_USERS_LABEL = 'Peak Daily Users';
const TOP_CATEGORY_LABEL = 'Top Category';
const NO_CATEGORY_PLACEHOLDER = '—';
const PEAK_USERS_HINT =
  'Distinct users are not additive across days, so this shows the highest ' +
  'number of unique users active in a single day.';

export function UsageKpiCards({ summary }: UsageKpiCardsProps) {
  const styles = useStyles();

  return (
    <div className={styles.kpiRow}>
      <Card className={styles.kpiCard} appearance="outline">
        <Text className={styles.kpiValue}>{summary.totalActions}</Text>
        <Text className={styles.kpiLabel}>{TOTAL_ACTIONS_LABEL}</Text>
      </Card>

      <Card className={styles.kpiCard} appearance="outline">
        <Text className={styles.kpiValue}>{summary.peakUniqueUsers}</Text>
        <span className={styles.kpiLabelRow}>
          <Text className={styles.kpiLabel}>{PEAK_USERS_LABEL}</Text>
          <Tooltip content={PEAK_USERS_HINT} relationship="description">
            <Info16Regular className={styles.infoIcon} aria-label="More info" />
          </Tooltip>
        </span>
      </Card>

      <Card className={styles.kpiCard} appearance="outline">
        <Text className={styles.kpiCategory}>
          {summary.topCategory ?? NO_CATEGORY_PLACEHOLDER}
        </Text>
        <Text className={styles.kpiLabel}>{TOP_CATEGORY_LABEL}</Text>
      </Card>
    </div>
  );
}
